import * as React from 'react'
// Const loader = import("../../assets/images/loader.svg");
function CircularProgress({ className }: { className?: any }) {
  return (<div className={`loader ${className}`}>{/* TODO: Add image here
    <img src={loader} alt="loader" /> */}
  </div>
  )
}
export default CircularProgress
